
import Vue from "vue";
import { Component, Inject } from "vue-property-decorator";
import { ANIMATION_CREATE, ANIMATION_EDIT } from "@/route-names";
import AnimationResponse from "@/api/dataSource/api/Spirit/Admin/Interfaces/Models/AnimationService/AnimationResponse";
import EventBus from "@models/eventBus";

@Component
export default class PageAnimationLibraryComponent extends Vue {
  @Inject("eventBus") eventBus: EventBus;
  createRouteName = ANIMATION_CREATE;
  editRouteName = ANIMATION_EDIT;
  columnNames = ["#", "Название", "Предпросмотр", "", ""];
  getDataFunc = this.$api.AnimationService.getAnimationsAsync.bind(
    this.$api.AnimationService
  );
  removeFunc = this.$api.AnimationService.deleteAnimationAsync.bind(
    this.$api.AnimationService
  );

  startDelete(item: AnimationResponse) {
    this.eventBus.deleteEntity.trigger({ id: item.Id });
  }
}
